export enum TermsAndConditionsEventTypes {
  TOGGLE_ACCEPTED = "TOGGLE_ACCEPTED",
}

export interface ToggleAcceptedEvent {
  type: TermsAndConditionsEventTypes.TOGGLE_ACCEPTED;
}

export type TermsAndConditionsEvents = ToggleAcceptedEvent;
